<script>
    export default {
        computed: {
            replaceAdditionalTag() { return this.$store.getters.MULTI_EDIT_REPLACE_ADDITIONAL_TAG },
            additionalTag() { return this.$store.getters.MULTI_EDIT_ADDITIONAL_TAG },
        },
        methods: {
            async setReplace(event) {
                await this.$store.commit('MULTI_EDIT_REPLACE_ADDITIONAL_TAG', event.target.checked);
            },
            async setAdditionalTag(event) {
                await this.$store.commit('MULTI_EDIT_ADDITIONAL_TAG', event.target.value);
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Additional Tags:</label>
        <label>
            <input 
                v-model="replaceAdditionalTag"
                @change="setReplace"
                type="checkbox" 
                class="mt_5 mb_10"
        >Replace value</label>
        <textarea 
            class="right_input"
            v-model="additionalTag"
            @change="setAdditionalTag"
        ></textarea>
    </div>
</template>